<template>
    <v-content>
        <v-app>
            <v-container grid-list-xl text-xs-center fluid class="container-transactions">
                <v-layout row wrap>
                    <v-flex xs4>
                        <v-select v-model="filter" :items="filterOptions" label="Filters" multiple dense append-icon="filter_list">
                           <template v-slot:selection="{ item, index }">
                                <v-chip small v-if="index < 3">
                                    <span>{{ item.text }}</span>
                                </v-chip>
                                <span v-if="index === 3" class="grey--text caption">(+{{ filter.length - 3 }} others)</span>
                            </template>
                        </v-select>
                    </v-flex>

                    <v-flex xs2>
                        <v-text-field v-model="search.transactionId" append-icon="search" label="Transaction ID" clearable @click:clear="resetFilter(search.transactionId)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="search.status" dense :items="statusOptions" label="Status" append-icon="search" @change="searchTransactions"></v-select>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.holder" append-icon="search" label="Card Holder" clearable @click:clear="resetFilter(search.holder)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2 v-if="filter.includes(2)">
                        <v-text-field v-model="search.bin" append-icon="search" label="BIN" clearable @click:clear="resetFilter(search.bin)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2 v-if="filter.includes(4)">
                        <v-text-field v-model="search.last4Digits" append-icon="search" label="Last 4 Digits" clearable @click:clear="resetFilter(search.last4Digits)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2 v-if="filter.includes(5)">
                        <v-text-field v-model="search.merchantTransactionId" append-icon="search" label="Merchant Transaction ID" clearable @click:clear="resetFilter(search.merchantTransactionId)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2 v-if="filter.includes(10)">
                        <v-text-field v-model="search.email" append-icon="search" label="Email Address" clearable @click:clear="resetFilter(search.email)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2 v-if="filter.includes(9)">
                        <v-text-field v-model="search.ip" append-icon="search" label="IP Address" clearable @click:clear="resetFilter(search.ip)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-select v-model="search.paymentType" :items="paymentTypeOptions" label="Payment Type" multiple dense append-icon="search" @change="searchTransactions">
                           <template v-slot:selection="{ item, index }">
                                <v-chip small v-if="index === 0">
                                    <span>{{ item.text }}</span>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text caption">(+{{ search.paymentType.length - 1 }} others)</span>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex xs2 v-if="filter.includes(6)">
                        <v-select v-model="search.paymentBrand" :items="paymentBrandOptions" dense label="Payment Brand" append-icon="search" @change="searchTransactions"></v-select>
                    </v-flex>
                    <v-flex xs2 v-if="filter.includes(0)">
                        <v-select v-model="search.threeDSecure" dense clearable @click:clear="resetFilter(search.threeDSecure)" :items="threeDSecureOptions" item-text="text" item-value="value" label="3D Secure" append-icon="search" @change="searchTransactions"></v-select>
                    </v-flex>
                    <v-flex xs2 v-if="filter.includes(1)">
                        <v-text-field v-model="search.amount" append-icon="search" label="Amount" clearable @click:clear="resetFilter(search.amount)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2 v-if="filter.includes(7)">
                        <v-select v-model="search.recurringType" dense :items="recurringTypeOptions" label="Recurring Type" append-icon="search" @change="searchTransactions"></v-select>
                    </v-flex>
                    <v-flex xs2 v-if="filter.includes(3)">
                        <v-select v-model="search.clearingInstitute" class="clearing-institute" dense clearable @click:clear="resetFilter(search.clearingInstitute)" :items="clearingInstituteOptions" item-text="clearingInstitute" item-value="clearingInstitute" label="Clearing Institutes" append-icon="search" @change="searchTransactions"></v-select>
                    </v-flex>
                    <v-flex xs2 v-if="filter.includes(8)">
                        <v-text-field v-model="search.resultCode" append-icon="search" label="Result Code" clearable @click:clear="resetFilter(search.resultCode)" @change="searchTransactions"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-dialog ref="fromDateDialog" v-model="fromDateModal" :return-value.sync="search.fromDate" persistent lazy full-width width="290px">
                            <v-text-field slot="activator" v-model="search.fromDate" label="From Date" append-icon="event" readonly></v-text-field>
                            <v-date-picker v-model="search.fromDate" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="fromDateModal = false">Cancel</v-btn>
                                <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <v-flex xs2>
                        <v-dialog ref="toDateDialog" v-model="toDateModal" :return-value.sync="search.toDate" persistent lazy full-width width="290px">
                            <v-text-field slot="activator" v-model="search.toDate" label="To Date" append-icon="event" readonly></v-text-field>
                            <v-date-picker v-model="search.toDate" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="toDateModal = false">Cancel</v-btn>
                                <v-btn flat color="primary" @click="handleDateChange">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                </v-layout>

                <v-layout row my-2 align-center>
                    <v-flex class="dialog-btn-container" text-xs-left>
                        <v-dialog v-model="merchantsDialog" scrollable max-width="400px">
                            <v-btn slot="activator" :outline="!leafCheck" color="primary" small dark class="ma-0 dialog-btn"><v-icon dark>list</v-icon></v-btn>
                            <v-card>
                                <v-toolbar dark color="primary">
                                    <v-toolbar-title>Select a merchant</v-toolbar-title> 
                                    <v-spacer></v-spacer>
                                </v-toolbar>

                                <v-card-text style="height: 300px;" class="dialog-tree-card pa-1">
                                    <tree :selected="this.leaf" @leaf="merchantFilter($event)"></tree>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="error" @click="leafCheck = false; leaf = []; searchTransactions();">Clear</v-btn>
                                    <v-btn color="primary" @click="merchantsDialog = false">Ok</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-flex>
                
                    <v-flex v-if="this.stats.totalTransactions > 0" xs6 class="text-xs-left">
                            <span class="font-weight-medium">Total Payment Transactions: {{ stats.totalTransactions }}</span> |
                            <span class="font-weight-medium">Successful: {{ stats.debitTransactions + stats.creditTransactions }}</span> |
                            <span class="font-weight-medium">Rejected: {{ stats.rejectedTransactions }}</span>
                    </v-flex>
                    <v-flex v-if="this.stats.totalTransactions > 0" xs6 class="text-xs-right pa-0">
                        <span class="mr-3">
                            <span class="green--text text--darken-2 font-weight-medium">Debit: {{ stats.debitTransactions }} / {{ new Intl.NumberFormat({ style: 'currency', minimumFractionDigits: 2 }).format(stats.debitAmount) }}</span> |
                            <span class="red--text text--darken-2 font-weight-medium">Credit: {{ stats.creditTransactions }} / {{ new Intl.NumberFormat({ style: 'currency', minimumFractionDigits: 2 }).format(stats.creditAmount) }}</span> |
                            <span class="font-weight-medium">Balance: {{ new Intl.NumberFormat({ style: 'currency' }).format(stats.debitAmount - stats.creditAmount) }}</span>
                        </span>
                        <v-btn class="downloadBtn" v-if="!download" color="primary" fab small dark @click="downloadReport(); download = true;">
                            <v-icon>mdi-download</v-icon>
                        </v-btn>
                        <v-progress-circular v-else class="downloadProgress" indeterminate color="primary"></v-progress-circular>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex xs12>
                        <v-data-table id="transactions-table" :headers="tableHeaders" :items="transactions" :rows-per-page-items="rowsPerPage" :loading="loading" class="elevation-1">
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <td v-if="props.item.status == 1" class="justify-center layout px-0 status-column">
                                    <v-icon small class="mr-2 vertical-align-middle" color="green">
                                        done
                                    </v-icon>
                                </td>
                                <td v-else-if="props.item.status == 0" class="justify-center layout px-0 status-column">
                                    <v-icon small class="mr-2 vertical-align-middle" color="red">
                                        clear
                                    </v-icon>
                                </td>
                                <td v-else class="justify-center layout px-0 status-column">
                                    <v-icon small class="mr-2 vertical-align-middle" color="blue">
                                        history
                                    </v-icon>
                                </td>
                                <td class="text-xs-left">{{ props.item.createdAt }}</td>
                                <td class="text-xs-left">{{ props.item.merchantName }}</td>
                                <td class="text-xs-left">{{ props.item.channelName }}</td>
                                <td class="text-xs-left">{{ props.item.holder }}</td>
                                <td class="text-xs-left">{{ props.item.paymentType }}</td>
                                <td class="text-xs-left">{{ props.item.merchantTransactionId }}</td>
                                <td class="text-xs-left">{{ props.item.resultCode }}</td>
                                <td v-if="props.item.paymentBrand == 'VISA' && props.item.paymentType != '3D'" class="text-xs-left">
                                    <div class="visa payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'VISA' && props.item.paymentType == '3D'" class="text-xs-left">
                                    <div class="verified-by-visa payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'VISAELECTRON' || props.item.paymentBrand == 'VISADEBIT'" class="text-xs-left">
                                    <div class="visa payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'MASTER' && props.item.paymentType != '3D'" class="text-xs-left">
                                    <div class="mastercard payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'MASTER' && props.item.paymentType == '3D'" class="text-xs-left">
                                    <div class="mastercard-securecode payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'AMEX'" class="text-xs-left">
                                    <div class="amex payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'MAESTRO'" class="text-xs-left">
                                    <div class="maestro payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'JCB'" class="text-xs-left">
                                    <div class="jcb payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'DINERS'" class="text-xs-left">
                                    <div class="diners payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'DISCOVER'" class="text-xs-left">
                                    <div class="discover payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'BCMC'" class="text-xs-left">
                                    <div class="bcmc payment-brand"></div>
                                </td>
                                <td v-else-if="props.item.paymentBrand == 'CHINAUNIONPAY'" class="text-xs-left">
                                    <div class="chinaunionpay payment-brand"></div>
                                </td>
                                <td v-else class="payment-brand-text">{{ props.item.paymentBrand }}</td>
                                <td class="text-xs-left">{{ props.item.amount }}</td>
                                <td class="text-xs-left">{{ props.item.currency }}</td>
                                <td class="text-xs-left">
                                    <v-btn icon @click="openDialog(props.item); tranInfo = props.item;">
                                        <v-icon color="grey">info</v-icon>
                                    </v-btn>         
                                </td>    
                            </template>
                        </v-data-table>
                        <transaction-information :visible="tranInfoDialog" :tranInfo="tranInfo" :references="references" :scheduleDates="scheduleDates" @closeDialog="tranInfoDialog = false" @getTransactions="getTransactions()"></transaction-information>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
    import axios from 'axios';
    import TransactionInformation from '../components/TransactionInformation.vue';
    import Tree from '../components/Tree.vue';

    export default {
        data() {
            return {
                pagination: { 'sortBy': 'processing_time', 'descending': true },
                search: {
                    transactionId: null,
                    status: null,
                    holder: null,
                    paymentType: [],
                    merchantTransactionId: null,
                    paymentBrand: null,
                    amount: null,
                    recurringType: null,
                    clearingInstitute: null,
                    resultCode: null,
                    uuid: { channel: null, merchant: null, division: null },
                    fromDate: new Date().toISOString().substr(0, 10),
                    toDate: new Date().toISOString().substr(0, 10),
                    userId: localStorage.user_id,
                    // merchantId: (localStorage.merchant_access).split(',')
                },
                stats: {
                    totalTransactions: 0,
                    debitAmount: 0,
                    debitTransactions: 0,
                    creditAmount: 0,
                    creditTransactions: 0,
                    rejectedTransactions: 0
                },
                filter: [],
                filterOptions: [
                            { value: 0, text: '3D Secure' },
                            { value: 1, text: 'Amount' },
                            { value: 2, text: 'BIN' },
                            { value: 3, text: 'Clearing Institute' },
                            { value: 10, text: 'Email Address' },
                            { value: 9, text: 'IP Address' },
                            { value: 4, text: 'Last 4 Digits' },
                            { value: 5, text: 'Merchant Transaction ID' },
                            { value: 6, text: 'Payment Brand' },
                            { value: 7, text: 'Recurring Type' },
                            { value: 8, text: 'Result Code' }
                ],
                statusOptions: [
                            { value: null, text: "All" },
                            { value: 0, text: "Failed" },
                            { value: 1, text: "Success" },
                            { value: 2, text: "Pending" }
                ],
                threeDSecureOptions: [
                            { value: 0, text: "Non 3D Secure" },
                            { value: 1, text: "3D Secure" }
                ],
                paymentTypeOptions: [
                                { value: "3D", text: "3D" },
                                { value: "CF", text: "Confirmation" },
                                { value: "CP", text: "Capture" },
                                { value: "CR", text: "Credit" },
                                { value: "DB", text: "Debit" },
                                { value: "DR", text: "Deregister" },
                                { value: "DS", text: "Deschedule" },
                                { value: "PA", text: "Pre-authorisation" },
                                { value: "RF", text: "Refund" },
                                { value: "RG", text: "Registration" },
                                { value: "RR", text: "Reregister" },
                                { value: "RS", text: "Reschedule" },
                                { value: "RV", text: "Reversal" },
                                { value: "SD", text: "Schedule" }
                ],
                paymentBrandOptions: [
                                { value: null, text: "All" },
                                { value: "AMEX", text: "AMEX" },
                                { value: "BCMC", text: "BCMC" },
                                { value: "CHINAUNIONPAY", text: "CHINAUNIONPAY" },
                                { value: "DINERS", text: "DINERS" },
                                { value: "DISCOVER", text: "DISCOVER" },
                                { value: "JCB", text: "JCB" },
                                { value: "MAESTRO", text: "MAESTRO" },
                                { value: "MASTER", text: "MASTERCARD" },
                                { value: "PAYSAFECARD", text: "PAYSAFECARD" },
                                { value: "VISA", text: "VISA" },
                                { value: "VISADEBIT", text: "VISADEBIT" },
                                { value: "VISAELECTRON", text: "VISAELECTRON" }
                ],
                recurringTypeOptions: [
                                { value: null, text: "All" },
                                { value: "INITIAL", text: "INITIAL" },
                                { value: "REPEATED", text: "REPEATED" }
                ],
                merchantOptions: [],
                clearingInstituteOptions: [],
                rowsPerPage:[10, 25, 50, 100],
                loading: true,
                transactions: [],
                tableHeaders: [{ text: 'Status', sortable: false, align: 'center' },
                               { text: 'Date', sortable: false },
                               { text: 'Merchant', sortable: false },
                               { text: 'Channel', sortable: false },
                               { text: 'Card Holder', value: 'holder', sortable: false },
                               { text: 'Payment Type', value: 'payment_type', sortable: false },
                               { text: 'Merchant Transaction ID', value: 'merchantTransactionId', sortable: false },
                               { text: 'Result Code', value: 'resultCode', sortable: false },
                               { text: 'Payment Brand', value: 'paymentBrand', sortable: false, align: 'center' },
                               { text: 'Amount', value: 'amount', sortable: false },
                               { text: 'Currency', value: 'currency', sortable: false },
                               { text: 'Information', value: '', sortable: false }],
                channels: [],
                menu: false,
                fromDateModal: false,
                toDateModal: false,
                tranInfoDialog: false,
                tranInfo: null,
                scheduleDates: null,
                references: null,
                merchantsDialog: false,
                leaf: [],
                leafCheck: false,
                download: false
            }
        },
        components: {
            'tree' : Tree,
            'transaction-information': TransactionInformation
        },
        beforeMount() {
            console.log(this.uuid);
            this.getTransactions();
            this.getClearingInstitutes();
            this.getTransactionsStats();
        },
        methods: {
            getTransactions() {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-get-transactions',
                data: { userId: localStorage.user_id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.transactions = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            searchTransactions() {
                this.loading = true;

                if(!this.leafCheck) {
                    this.search.uuid = { channel: null, merchant: null, division: null };
                }
                this.getTransactionsStats();

                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-search-transactions',
                data: { search: this.search },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.transactions = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            getClearingInstitutes() {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-get-clearing-institutes',
                data: { userId: localStorage.user_id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.clearingInstituteOptions = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            getTransactionsStats() {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-get-stats',
                data: { search: this.search },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.stats.totalTransactions = (response.data.reduce((p, c) => p + c.transactions, 0) || 0);
                    this.stats.debitAmount = (response.data.find(t => t.paymentType == 'DB' && t.status == 1) || { amount : 0 }).amount;
                    this.stats.debitTransactions = (response.data.find(t => t.paymentType == 'DB' && t.status == 1) || { transactions : 0 }).transactions;
                    this.stats.creditAmount = (response.data.find(t => t.paymentType == 'RF' && t.status == 1) || { amount : 0 }).amount; 
                    this.stats.creditTransactions = (response.data.find(t => t.paymentType == 'RF' && t.status == 1) || { transactions : 0 }).transactions;
                    this.stats.rejectedTransactions = (response.data.find(t => t.status == 0) || { transactions : 0 }).transactions;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            },
            resetFilter(field) {
                this.field = null;
                this.searchTransactions();
            },
            handleDateChange() {
                if(this.search.toDate < this.search.fromDate) {
                    this.search.fromDate = this.search.toDate;
                }
                this.$refs.fromDateDialog.save(this.search.fromDate);
                this.$refs.toDateDialog.save(this.search.toDate);
                this.searchTransactions();
            },
            merchantFilter(leaf) {
                if(typeof leaf !== "undefined" && 'id' in leaf) {

                    this.leafCheck = true;

                    if('children' in leaf) {
                        this.search.uuid = { 'merchant': leaf.id };
                        if('children' in leaf.children[0]) {
                            this.search.uuid = { 'division': leaf.id };
                        }
                    }
                    else {
                        this.search.uuid = { 'channel': leaf.id };
                    }
                    this.searchTransactions();
                }
            },
            openDialog(transaction) {
                axios({
                    method: 'post',
                    url: 'https://controlapi.totalprocessing.com/api/get-references',
                    data: { transactionId: transaction.uuid, paymentType: transaction.paymentType },
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        this.references = response.data;
                        if(transaction.paymentType != 'SD') {
                            this.tranInfoDialog = true;
                        }
                        else {
                            let reference = this.references.filter(t => t.paymentType == 'DS');
                            axios({
                                method: 'post',
                                url: 'https://controlapi.totalprocessing.com/api/cron-to-dates',
                                data: { cron: JSON.parse(transaction.json).payload.job.execution.expression, startDate: transaction.processingTime, reference: reference },
                                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                                })
                                .then(response => {
                                    this.scheduleDates = response.data;                               
                                    this.tranInfoDialog = true;
                                })
                                .catch(e => {
                                    this.errors.push(e)
                            })
                        }
                    })
                    .catch(e => {
                        this.errors.push(e)
                })
            },
            downloadReport() {
                axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-get-transactions-csv',  
                data: { merchantUuid: this.merchantId, search: this.search },              
                responseType: 'blob',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'transactions-report.csv');
                    document.body.appendChild(link);
                    link.click();
                    this.download = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        }
    }
</script>

<style>
    #transactions-table {
        white-space: nowrap;
        margin-top: 10px;
    }

    #transactions-table .status-column {
        margin-top: 0px;
    }

    .cursor {
        cursor: pointer;
    }

    .container.grid-list-xl.container-transactions .layout .flex {
        padding: 0px 12px;
    }

    .clearing-institute .v-select__selection {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
    }

    .clearing-institute .v-select__selections {
        width: 70%;
    }

    .v-date-picker-table .v-btn {
        outline: 0px;
        -webkit-appearance: none;
    }

    table > tbody > tr td.result-code {
        color: #1976D1;
        font-weight: 500;
    }

    .v-icon {
        display: inline-flex !important;
    }

    .payment-brand {
        margin: 0 auto;
    }

    .payment-brand-text {
        text-align: center;
    }

    .visa {
        background: url('../assets/visa.svg');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        width: 50px;
        height: 16px;
    }

    .mastercard {
        background: url('../assets/mastercard.svg');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        width: 45px;
        height: 35px;
    }

    .verified-by-visa {
        background: url('../assets/verified-by-visa.svg');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        width: 60px;
        height: 30px;
    }

    .mastercard-securecode {
        background: url('../assets/mastercard-securecode.svg');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        width: 70px;
        height: 22px;
    }

    .amex {
        background: url('../assets/amex.svg');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        width: 60px;
        height: 30px;
    }

    .maestro {
        background: url('../assets/maestro.svg');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        width: 55px;
        height: 33px;
    }

    .jcb {
        background: url('../assets/jcb.svg');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        width: 55px;
        height: 36px;
    }

    .diners {
        background: url('../assets/diners.svg');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        width: 70px;
        height: 19px;
    }

    .discover {
        background: url('../assets/visa.svg');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        width: 70px;
        height: 12px;
    }

    .bcmc {
        background: url('../assets/bcmc.jpg');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        width: 50px;
        height: 33px;
    }

    .chinaunionpay {
        background: url('../assets/chinaunionpay.svg');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        width: 50px;
        height: 32px;
    }

    .dialog-btn-container .v-btn,
    .dialog-btn-container .dialog-btn {
        min-width: 40px;
        margin:0;
    }

    .tree-container .layout {
        border-right: 1px solid #bbb;
    }

    button.v-btn {
        outline: none !important;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
        -moz-appearance:textfield;
    }

    .transaction-history-container:not(:last-child) {
        margin-bottom: 10px;
    }

    table.v-table thead th {
        font-weight: 600 !important;
        font-size: 12px !important;
    }
    
    table.v-table tbody td {
        font-size: 10px !important;
    }

    .transaction-history-table > div > table.v-table tbody td,
    .transaction-history-table > div > table.v-table tbody th,
    .transaction-history-table > div > table.v-table > thead > tr:first-child {
        height: 30px;
    }

    td.text-xs-left.highlightRow {
        font-weight: bold;
    }

    .transaction-tab hr {
        margin: 0 0 5px 0;
    }

    .transaction-tab .v-card__title {
        padding: 5px 16px;
    }

    .transaction-tab .v-list--dense .v-list__tile:not(.v-list__tile--avatar) {
        height: 25px;
    }

    .transaction-tab .v-list--dense {
        padding-top: 0px;
    }
</style>
